export default __webpack_public_path__ + "static/media/app_store_badge.a1838441.svg";